import { ViewDensity, ViewType } from "@common/types/views/views";
import {
    HistoryRuleGroupDetailsColumn,
    HistoryRuleGroupDetailsView,
} from "./historyRuleGroupDetailsView";

export const defaultHistoryRuleGroupDetailsView: HistoryRuleGroupDetailsView = {
    type: ViewType.HISTORY_UPDATED_TRANSACTION,
    columns: [
        { id: HistoryRuleGroupDetailsColumn.TIME },
        { id: HistoryRuleGroupDetailsColumn.GROUP_NAME },
    ],
    filters: {},
    options: {
        selection: true,
        density: ViewDensity.MD,
    },
};

export const createDefaultHistoryRuleGroupUpdateView =
    (): HistoryRuleGroupDetailsView => ({
        type: ViewType.HISTORY_UPDATED_TRANSACTION,
        columns: [
            { id: HistoryRuleGroupDetailsColumn.TIME },
            { id: HistoryRuleGroupDetailsColumn.GROUP_NAME },
            { id: HistoryRuleGroupDetailsColumn.PREVIOUS },
            { id: HistoryRuleGroupDetailsColumn.MODIFIED },
        ],
        filters: {},
        options: {
            selection: true,
            density: ViewDensity.MD,
        },
    });
